import { ICheckboxStyles } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontWeights, Sizes } from '../../themes/styles';

export const checkboxStylesDefault = (theme: IH2OTheme): Partial<ICheckboxStyles> => ({
  root: {
    '&.is-checked': {
      '.ms-Checkbox-checkbox': {
        backgroundColor: theme.semanticColors?.buttonPrimaryBackground,
        borderColor: theme.semanticColors?.buttonPrimaryBackground,
      },
    },
    '&.is-checked.has-error': {
      '.ms-Checkbox-checkbox': {
        background: theme.semanticColors?.inputErrorMessageText,
      },
      '.ms-Checkbox-checkmark': {
        color: theme.semanticColors?.checkboxCheckMarkErr,
      },
    },
    '&.is-disabled': {
      pointerEvents: 'none',
      '.ms-Checkbox-checkbox': {
        borderColor: theme.semanticColors?.inputDisabledBorder,
      },
      '.ms-Checkbox-text': {
        color: theme.semanticColors?.textDisabled,
      },
      '.ms-Checkbox-checkmark': {
        color: theme.semanticColors?.textDisabled,
      },
    },
    '&.has-error': {
      '.ms-Checkbox-checkbox': {
        borderColor: theme.semanticColors?.inputErrorBorder,
      },
      '.ms-Checkbox-text': {
        color: theme.semanticColors?.inputErrorMessageText,
      },
      '.ms-Checkbox-checkmark': {
        color: theme.semanticColors?.checkboxCheckMark,
      },
    },
  },
  checkbox: {
    width: 16,
    height: 16,
    borderColor: theme.semanticColors?.inputReadOnlyText,
    marginRight: 8,
    borderRadius: Sizes.borderRadius,
  },
  checkmark: {
    color: theme.semanticColors?.checkboxCheckMark,
  },
  text: {
    color: theme.semanticColors?.inputReadOnlyText,
    lineHeight: 16,
  },
  label: {
    color: theme.semanticColors?.inputReadOnlyText,
  },
});

export const checkboxStylesCircle: Partial<ICheckboxStyles> = {
  root: { display: 'inline-block' },
  checkbox: { borderRadius: '50%', fontSize: 11, fontWeight: FontWeights.bold },
};

export const checkboxStylesReadOnly: Partial<ICheckboxStyles> = {
  root: { pointerEvents: 'none' },
};
